import React from 'react';
import {ListItem, ListItemText  } from '@mui/material';
import Icon from '@mui/material/Icon';
import ListaDeGrupo from 'components/ListaDeGrupo';

export default function Grupo(props) {

    if (props.group===null || props.group === undefined){
        return <div></div>;
    }

    return (
      <div>
        {(props.group.length===1) ? (
            <ListItem button key={props.group[0].name} >
                <Icon>{props.group[0].icon}</Icon>
                <ListItemText primary={props.group[0].name} />
            </ListItem>
        ):( <ListaDeGrupo listOfGroup={props.group}/>  )
        }
      </div>
    );
}